import React from 'react';
import Stats from './views/stats';

class App extends React.Component {	
    render() {return (<Stats />)    }
}

export default App;